import src from "IMAGE";
export default { src, width: 307, height: 337, blurWidth: 7, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAAR0lEQVR42p2KWwoAIQwDvf9tl1V8N6ZQRf20ZUJg4mDXIEhMj4yPTXFTdspMGVDwsymHrEwdRDZlSbFBY1ZjyTmQ7Q9537sckbreU1lbV2cAAAAASUVORK5CYII="};
